































































































































































































// import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import UUIFComponents from '@/shared/uuifComponent';
import { tooltip } from '@libs-uuif/shared/tooltip-dir';
import { SelectOption } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import { SwTextarea } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { SwStatusInfo } from '@sonicwall/unified-ui-framework/src/shared/sw-status-info';
import { MsspModalObject, TenantModalObject, CountryListType, StateListType, TenantModalObjectToAddAPI, MSSPDetailsContent, TenantModalObjectToEditAPI, MSSPPrefilterResponseType, MsspPrefilterList,
  TenantPrefilterList } from '../types';
import { stateList } from '../stateList.data';
import  { MswApiService } from '@/shared/msw-api-service';
import { AddressFormObjType } from '../../../shared/address-verification-component/types';
import AddressVerificationComponent from '../../../shared/address-verification-component/address-verification-component.vue';
import RegexValidators from '../../../shared/regex-validators';
import { currentUserKey } from '@/shared/msw-constants';

const cssPrefix = 'add-tenant-modal';
@Component({
  components: {
    ...UUIFComponents,
    SwTextarea,
    AddressVerificationComponent,
    SwStatusInfo,
  }, directives: {
    tooltip,
  },
})
export default class AddTenantModal extends SwExtendedVue {

  @Prop({ type: String })
  msspType: string;

  @Prop({ type: String })
  modalMode: string;

  cssPrefix = cssPrefix;
  msspOptions: SelectOption[] = [];
  message: string = '';
  newMsspModalObject:MsspModalObject = {
    MSSPname: '',
    emailAddress: '',
    contactName: '',
    companyName: '',
    phoneNumber: '',
    streetAddress: '',
    city: '',
    country: '',
    state: '',
    zipCode: '',
    isDefaultGroup: 'YES',
    MSSPID: '',
    additionalComments: '',
    province: '',
    firstName: '',
    lastName: '',
    msspNumber: '',
    msspContractid: '',
  };
  tenantModalObject: TenantModalObject = {
    MSSPname: '',
    tenantName: '',
    contactName: '',
    companyName: '',
    emailAddress: '',
    phoneNumber: '',
    streetAddress: '',
    cityName: '',
    countryName: 'US',
    stateName: '',
    zipCode: '',
    additionalMessage: '',
    province: '',
    productGroupId: '',
    tenantNumber: '',
    tenantContractId: '',
  };
  msspDetails: MSSPDetailsContent = {
    msspName: '',
    organizationName: '',
    msspGoverningList: [],
  };
  // partyGroupId: string = '';
  addressVerificationNeeded: string = '';
  enableAddressVerificationFormModal: boolean = false;
  addressFormSuggestedObj:AddressFormObjType = {
    addressLine1: '',
    addressLine2: '',
    addressLine3: '',
    country: '',
    city: '',
    postalCode: '',
    state: '',
    province: '',
    countryLabel: '',
    stateLabel: '',
  };
  addressFormAppliedObj:AddressFormObjType = {
    addressLine1: '',
    addressLine2: '',
    addressLine3: '',
    country: '',
    city: '',
    postalCode: '',
    state: '',
    province: '',
    countryLabel: '',
    stateLabel: '',
  };
  addressType = '';
  addressVerificationEnabled: boolean = false;
  showErrorMsg: boolean = false;
  inValidEmail: boolean = false;
  inValidPhone: boolean = false;
  countryList = [];
  showHeaderErrorMessage = false;
  msspPrefilterResponseFromApi: MSSPPrefilterResponseType;
  addressVerificationMsg = '';
  showTenantErrorMsg: boolean = false;
  tenantDuplicateShowError = false;
  tenantList: string[] = [];
  apiFailedAddressVerificationMesssage = '';
  checkTenantNameInputChanged: boolean = false;

  onTenantNameInput(value: string) {
    if (value.length <= 50) {
      this.tenantModalObject.tenantName = value;
      this.checkTenantNameInputChanged = true;
    } else {
      this.showTenantErrorMsg = true;
      this.checkTenantNameInputChanged = false;
    }
  }
  onTenantInput(type: string) {
    switch (type) {
      case'tenantName':
        this.tenantModalObject.tenantName = this.tenantModalObject.tenantName.trim();
        this.tenantDuplicateShowError = false;
        this.fetchTenantFlag(this.tenantModalObject.tenantName);
        break;
      case'tenantNumber':
        this.tenantModalObject.tenantNumber = this.tenantModalObject.tenantNumber.trim();
        break;
      case 'tenantContractId':
        this.tenantModalObject.tenantContractId = this.tenantModalObject.tenantContractId.trim();
        break;
      case'contactName':
        this.tenantModalObject.contactName = this.tenantModalObject.contactName.trim();
        break;
      case'companyName':
        this.tenantModalObject.companyName = this.tenantModalObject.companyName.trim();
        break;
      case'emailAddress':
        this.tenantModalObject.emailAddress = this.tenantModalObject.emailAddress.trim();
        break;
      case'phoneNumber':
        this.tenantModalObject.phoneNumber = this.tenantModalObject.phoneNumber.trim();
        break;
      case'streetAddress':
        this.tenantModalObject.streetAddress = this.tenantModalObject.streetAddress.trim();
        break;
      case'cityName':
        this.tenantModalObject.cityName = this.tenantModalObject.cityName.trim();
        break;
      case'countryName':
        this.tenantModalObject.countryName = this.tenantModalObject.countryName.trim();
        break;
      case'stateName':
        this.tenantModalObject.stateName = this.tenantModalObject.stateName.trim();
        break;
      case'province':
        this.tenantModalObject.province = this.tenantModalObject.province.trim();
        break;
      case'zipCode':
        this.tenantModalObject.zipCode = this.tenantModalObject.zipCode.trim();
        break;
    }
  }

  onMsspChange() {
    this.msspOptions.map((ele: SelectOption) => {
      if (ele.id === this.tenantModalObject.MSSPname) {
        this.showHeaderErrorMessage = ele.value === 'INACTIVE';
        if (ele.value === 'INACTIVE') {
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: this.$t('tenantMgmt.provision.messages.newMssp') });
        }
      }
    });
  }

  get stateOptions(): SelectOption[] {
    const filterStateOption: SelectOption[] = [];
    stateList.map((ele: StateListType) => {
      if (this.tenantModalObject.countryName === ele.country) {
        filterStateOption.push({
          id: ele.id,
          label: ele.label,
          value: ele.id,
        });
      }
    });
    return filterStateOption;
  }

  get countryOptions(): SelectOption[] {
    return this.countryList.map((list: CountryListType) => {
      return {
        id: list.countryCode,
        value: list.countryCode,
        label: list.countryName,
      };
    });
  }

  onCancel() {
    this.$emit('oncloseTenantModal');
  }

  addTenantApiCall() {
    this.apiFailedAddressVerificationMesssage = '';
    return new Promise((res: any, rej: any) => {
      const addTenant: TenantModalObjectToAddAPI = {
        productGroup: this.tenantModalObject.tenantName,
        // partyGroupId: this.partyGroupId,
        source: 'WORKSPACE',
        isAddressVerified: 'FALSE',
        isAddressVerificationCompleted: '',
        isFromTenantManagement: 'TRUE',
        msspTenantNumber: this.tenantModalObject.tenantNumber,
        tenantContractId: this.tenantModalObject.tenantContractId,
        MSSPId: this.msspType !== 'select' ? this.newMsspModalObject.MSSPID : this.tenantModalObject.MSSPname,
        tenantAddress: {
          companyName: this.tenantModalObject.companyName,
          contactName: this.tenantModalObject.contactName,
          emailAddress: this.tenantModalObject.emailAddress,
          streetAddress: this.tenantModalObject.streetAddress,
          city: this.tenantModalObject.cityName,
          state: this.tenantModalObject.stateName,
          zipCode: this.tenantModalObject.zipCode,
          country: this.tenantModalObject.countryName,
          phoneNumber: this.tenantModalObject.phoneNumber,
          province: this.tenantModalObject.province,
          additionalComments: this.tenantModalObject.additionalMessage,
          MSSPID: this.msspType !== 'select' ? this.newMsspModalObject.MSSPID : this.tenantModalObject.MSSPname,
          MSSPName: this.fetchMsspName(this.msspType !== 'select' ? this.newMsspModalObject.MSSPID : this.tenantModalObject.MSSPname),
        },
      };
      if (this.addressVerificationEnabled) {
        addTenant.isAddressVerified = 'TRUE';
        addTenant.isAddressVerificationCompleted = 'TRUE';
      }
      return MswApiService.tenant.addTenant(addTenant)
      .then((resp: any) => {
        this.addressVerificationNeeded = resp.msgCode;
        if (resp.operationStatus === 'OK') {
          if (this.addressVerificationEnabled) {
            if ((this.addressVerificationNeeded === 'MSWAPP:INVALIDADDRESS')) {
              this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
              this.onBackFn();
            } else {
              this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
            }
          } else {
            if ((this.addressVerificationNeeded === 'MSWAPP:UPDATETENANTADDRESSUCCESS') || (this.addressVerificationNeeded === 'MSWAPP:CREATPRODUCTGROUPSUCCESS')) {
              this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
            }
          }
          this.addressVerificationEnabled = true;
          const suggestedAddress = resp.addressResp || {};
          this.addressVerificationMsg = resp.msgDesc !== 'Success' ? resp.msgDesc : '';
          this.addressFormSuggestedObj = {
            addressLine1: suggestedAddress.address || '',
            addressLine2: '',
            addressLine3: '',
            city: suggestedAddress.city || '',
            country: suggestedAddress.country || '',
            state: suggestedAddress.stateCode || '',
            province: suggestedAddress.province || '',
            postalCode: suggestedAddress.zipCode || '',
            countryLabel: this.fetchCountryName(suggestedAddress.country),
            stateLabel: this.fetchStateName(suggestedAddress.stateCode || ''),
          };
          this.tenantModalObject.tenantId = resp.productGroupId;
          this.$store.commit('TenantManagementStoreModule/setNewTenantModalObject', { newTenantModalObject: this.tenantModalObject });
          this.$store.commit('TenantManagementStoreModule/setNewProductObjectMsspName', { MSSPname: this.tenantModalObject.MSSPname }); // sending the mssp name and tenant name to productpage
          this.$store.commit('TenantManagementStoreModule/setNewProductObjectTenantName', { tenantName: this.tenantModalObject.tenantId });
        } else {
          this.apiFailedAddressVerificationMesssage = 'failed';
          this.addressVerificationNeeded = '';
          this.addressVerificationEnabled = false;
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
          rej(false);
        }
        res(resp);
      });
      // .catch((err: any): any => {
      //   // this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: err.msgDesc });
      //   // rej(false);
      // });
    });
  }

  fetchMsspName(id: string): string {
    const filteredObj = this.msspOptions.filter((ele: SelectOption) => ele.id === id)[0];
    const filteredName: string = filteredObj ? filteredObj.label.toString() : '';
    return filteredName;
  }

  fetchCountryName(id: string): string {
    const filteredObj = this.countryOptions.filter((ele: SelectOption) => ele.id === id)[0];
    const filteredName: string = filteredObj ? filteredObj.label.toString() : '';
    return filteredName;
  }

  fetchStateName(id: string): string {
    const filteredObj = this.stateOptions.filter((ele: SelectOption) => ele.id === id)[0];
    const filteredName: string = filteredObj ? filteredObj.label.toString() : '';
    return filteredName;
  }

  fetchStateCode(name: string): string {
    const filteredObj = this.stateOptions.filter((ele: SelectOption) => ele.label === name)[0];
    const filteredCode: string = filteredObj ? filteredObj.id.toString() : '';
    return filteredCode;
  }

  editTenantApiCall() {
    this.apiFailedAddressVerificationMesssage = '';
    console.warn(this.msspType !== 'select', this.newMsspModalObject.MSSPID, this.tenantModalObject.MSSPname);
    const msspId: any = /^-?\\d/.test(this.tenantModalObject.MSSPname) ? this.tenantModalObject.MSSPname :
    (this.msspOptions.filter((ele:any) => ele.label === this.tenantModalObject.MSSPname))[0].id;
    return new Promise((res: any, rej: any) => {
      const editTenant: TenantModalObjectToEditAPI = {
        productGroupId: this.tenantModalObject.productGroupId,
        isAddressVerificationCompleted: 'FALSE',
        msspTenantNumber: this.tenantModalObject.tenantNumber,
        tenantContractId: this.tenantModalObject.tenantContractId,
        tenantAddress: {
          companyName: this.tenantModalObject.companyName,
          contactName: this.tenantModalObject.contactName,
          emailAddress: this.tenantModalObject.emailAddress,
          streetAddress: this.tenantModalObject.streetAddress,
          city: this.tenantModalObject.cityName,
          state: this.tenantModalObject.stateName,
          zipCode: this.tenantModalObject.zipCode,
          country: this.tenantModalObject.countryName,
          phoneNumber: this.tenantModalObject.phoneNumber,
          province: this.tenantModalObject.province,
          additionalComments: this.tenantModalObject.additionalMessage,
          MSSPID: this.msspType !== 'select' ? this.newMsspModalObject.MSSPID : msspId,
          MSSPName: this.fetchMsspName(this.msspType !== 'select' ? this.newMsspModalObject.MSSPID : this.tenantModalObject.MSSPname),
          tenantName: this.tenantModalObject.tenantName,
        },
      };
      if (this.addressVerificationEnabled) {
        editTenant.isAddressVerificationCompleted = 'TRUE';
      }
      return MswApiService.tenant.editTenant(editTenant)
      .then((resp: any) => {
        this.addressVerificationNeeded = resp.msgCode;
        if (resp.operationStatus === 'OK') {
          if (this.addressVerificationEnabled) {
            if ((this.addressVerificationNeeded === 'MSWAPP:INVALIDADDRESS')) {
              this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
              this.onBackFn();
            } else {
              this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
            }
          } else {
            if ((this.addressVerificationNeeded === 'MSWAPP:UPDATETENANTADDRESSUCCESS') || (this.addressVerificationNeeded === 'MSWAPP:CREATPRODUCTGROUPSUCCESS')) {
              this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
            }
          }
          this.addressVerificationEnabled = true;
          this.addressVerificationMsg = resp.msgDesc !== 'Success' ? resp.msgDesc : '';
          const suggestedAddress = resp.addressResp || {};
          this.addressFormSuggestedObj = {
            addressLine1: suggestedAddress.address || '',
            addressLine2: '',
            addressLine3: '',
            city: suggestedAddress.city || '',
            country: suggestedAddress.country || '',
            state: suggestedAddress.stateCode || '',
            province: suggestedAddress.province || '',
            postalCode: suggestedAddress.zipCode || '',
            countryLabel: this.fetchCountryName(suggestedAddress.country),
            stateLabel: this.fetchStateName(suggestedAddress.stateCode || ''),
          };
          this.$store.commit('TenantManagementStoreModule/setNewTenantModalObject', { newTenantModalObject: this.tenantModalObject });
        } else {
          this.apiFailedAddressVerificationMesssage = 'failed';
          this.addressVerificationNeeded = '';
          this.addressVerificationEnabled = false;
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
          rej(false);
        }
        res(resp);
      });
    });
  }

  checkEmail() {
    const regexStr =  new RegExp(RegexValidators.email);
    this.inValidEmail = !regexStr.test(this.tenantModalObject.emailAddress);
  }

  checkPhone() {
    const regexStr = new RegExp(RegexValidators.phoneNo);
    this.inValidPhone = !regexStr.test(this.tenantModalObject.phoneNumber);
  }

  fetchTenantFlag(tenantName: string) {
    const index = this.tenantList.findIndex((ele: string) => ele === tenantName);
    if (index !== -1 && this.checkTenantNameInputChanged) {
      this.tenantDuplicateShowError = true;
      return true;
    }
    return false;
  }

  get getValidationFlag() {
    let flag = false;
    const tenantDuplicateFlag = this.fetchTenantFlag(this.tenantModalObject.tenantName);
    const stateFlag = (((this.tenantModalObject.countryName === 'US') || this.tenantModalObject.countryName === 'CA')) ? this.tenantModalObject.stateName !== '' : this.tenantModalObject.province !== '';
    flag = (this.tenantModalObject.MSSPname !== '') && (this.tenantModalObject.emailAddress !== '') && (this.tenantModalObject.contactName !== '') && (this.tenantModalObject.companyName !== '')
    && (this.tenantModalObject.phoneNumber !== '') && (this.tenantModalObject.streetAddress !== '') && (this.tenantModalObject.cityName !== '') && !this.inValidEmail
      && (this.tenantModalObject.countryName !== '') && stateFlag && (this.tenantModalObject.zipCode !== '') /* && (this.tenantModalObject.tenantNumber !== '') */ && (this.tenantModalObject.phoneNumber !== '') && (this.tenantModalObject.tenantName !== '')
      && (this.tenantModalObject.tenantName.length <= 50) && !tenantDuplicateFlag && !this.inValidPhone;
    return flag;
  }

  async onSave() {
    this.showErrorMsg = true;
    if (this.getValidationFlag) {
      this.addressType = 'save';
      this.addressVerificationNeeded = '';
      try {
        this.$store.commit('startLoading');
        if (this.modalMode === 'add') {
          await this.addTenantApiCall();
        } else {
          await this.editTenantApiCall();
        }
        if ((this.addressVerificationNeeded !== '') && (this.addressVerificationNeeded !== 'MSWAPP:ADDRESSVERIFICATIONNOTNEEDED') && (this.addressVerificationNeeded !== 'MSWAPP:VALIDADDRESS')
        && (this.addressVerificationNeeded !== 'MSWAPP:UPDATETENANTADDRESSUCCESS') && (this.addressVerificationNeeded !== 'MSWAPP:CREATPRODUCTGROUPSUCCESS')) {
          await this.processAddressVerification();
        } else {
          if ((this.addressVerificationNeeded === 'MSWAPP:ADDRESSVERIFICATIONNOTNEEDED') || (this.addressVerificationNeeded === 'MSWAPP:VALIDADDRESS')) {
            if (this.modalMode === 'add') {
              await this.addTenantApiCall();
            } else {
              await this.editTenantApiCall();
            }
          }
        }
        if ((this.addressVerificationNeeded === 'MSWAPP:UPDATETENANTADDRESSUCCESS') || (this.addressVerificationNeeded === 'MSWAPP:CREATPRODUCTGROUPSUCCESS')) {
          this.$emit('onSaveCloseTenantModal');
        }
        this.$store.commit('stopLoading');
      } catch {
        this.$store.commit('stopLoading');
      }
    }
    this.checkTenantNameInputChanged = false;
  }

  async onNext() {
    this.showErrorMsg = true;
    if (this.getValidationFlag) {
      this.addressType = 'next';
      this.addressVerificationNeeded = '';
      try {
        this.$store.commit('startLoading');
        if (this.modalMode === 'add') {
          await this.addTenantApiCall();
        } else {
          await this.editTenantApiCall();
        }
        if ((this.addressVerificationNeeded !== '') && (this.addressVerificationNeeded !== 'MSWAPP:ADDRESSVERIFICATIONNOTNEEDED') && (this.addressVerificationNeeded !== 'MSWAPP:VALIDADDRESS')
          && (this.addressVerificationNeeded !== 'MSWAPP:UPDATETENANTADDRESSUCCESS') && (this.addressVerificationNeeded !== 'MSWAPP:CREATPRODUCTGROUPSUCCESS')) {
          await this.processAddressVerification();
        } else {
          if ((this.addressVerificationNeeded === 'MSWAPP:ADDRESSVERIFICATIONNOTNEEDED') || (this.addressVerificationNeeded === 'MSWAPP:VALIDADDRESS')) {
            if (this.modalMode === 'add') {
              await this.addTenantApiCall();
            } else {
              await this.editTenantApiCall();
            }
          }
          if ((this.addressVerificationNeeded === 'MSWAPP:UPDATETENANTADDRESSUCCESS') || (this.addressVerificationNeeded === 'MSWAPP:CREATPRODUCTGROUPSUCCESS')) {
            this.$emit('nextProductClick', { MSSPID: this.tenantModalObject.MSSPname, tenantID: this.tenantModalObject.tenantId });
          }
        }
        this.$store.commit('stopLoading');
        if (this.msspType === '' && this.modalMode === 'add') {
          this.tenantModalObject.MSSPname = this.newMsspModalObject.MSSPID.toString();
        }
        this.$store.commit('TenantManagementStoreModule/setNewTenantModalObject', { newTenantModalObject: this.tenantModalObject });
      } catch {
        this.$store.commit('stopLoading');
      }
    }
    this.checkTenantNameInputChanged = false;
  }

  processAddressVerification() {
    return new Promise((res) => {
      this.addressFormAppliedObj = {
        addressLine1: this.tenantModalObject.streetAddress,
        addressLine2: '',
        addressLine3: '',
        city: this.tenantModalObject.cityName,
        country: this.tenantModalObject.countryName,
        state: this.tenantModalObject.stateName,
        postalCode: this.tenantModalObject.zipCode,
        province: this.tenantModalObject.province,
        countryLabel: this.fetchCountryName(this.tenantModalObject.countryName),
        stateLabel: this.fetchStateName(this.tenantModalObject.stateName),
      };
      this.enableAddressVerificationFormModal = true;
      res(true);
    });
  }

  resetAddress() {
    this.addressVerificationEnabled = false;
    this.addressFormAppliedObj = {
      addressLine1: '',
      addressLine2: '',
      addressLine3: '',
      city: '',
      country: '',
      state: '',
      postalCode: '',
      province: '',
      countryLabel: '',
      stateLabel: '',
    };
    this.addressFormSuggestedObj = {
      addressLine1: '',
      addressLine2: '',
      addressLine3: '',
      city: '',
      country: '',
      state: '',
      postalCode: '',
      province: '',
      countryLabel: '',
      stateLabel: '',
    };
  }

  onCloseAddressFormModal() {
    this.onBackFn();
  }

  onBackFn() {
    this.addressVerificationEnabled = false;
    this.enableAddressVerificationFormModal = false;
  }

  async onUseSuggestedAddressFn() {
    try {
      this.$store.commit('startLoading');
      this.tenantModalObject.streetAddress = this.addressFormSuggestedObj.addressLine1;
      this.tenantModalObject.cityName = this.addressFormSuggestedObj.city;
      this.tenantModalObject.stateName = this.addressFormSuggestedObj.state;
      this.tenantModalObject.countryName = this.addressFormSuggestedObj.country;
      this.tenantModalObject.zipCode = this.addressFormSuggestedObj.postalCode;
      if (this.modalMode === 'add') {
        await this.addTenantApiCall();
      } else {
        await this.editTenantApiCall();
      }
      if (this.addressVerificationNeeded === 'MSWAPP:INVALIDADDRESS') {
        this.processAddressVerification();
      } else if (this.apiFailedAddressVerificationMesssage === 'failed') {
        this.onBackFn();
      } else if (this.addressType === 'save') {
        this.$emit('onSaveCloseTenantModal');
      } else {
        this.$emit('nextProductClick');
      }
      this.$store.commit('stopLoading');
    } catch {
      if (this.apiFailedAddressVerificationMesssage === 'failed') {
        this.onBackFn();
      }
      this.$store.commit('stopLoading');
    }
  }

  async onUseAppliedAddressFn() {
    try {
      this.$store.commit('startLoading');
      if (this.modalMode === 'add') {
        await this.addTenantApiCall();
      } else {
        await this.editTenantApiCall();
      }
      if (this.addressVerificationNeeded === 'MSWAPP:INVALIDADDRESS') {
        this.processAddressVerification();
      } else if (this.apiFailedAddressVerificationMesssage === 'failed') {
        this.onBackFn();
      } else if (this.addressType === 'save') {
        this.$emit('onSaveCloseTenantModal');
      } else {
        this.$emit('nextProductClick');
      }
      this.$store.commit('stopLoading');
    } catch {
      if (this.apiFailedAddressVerificationMesssage === 'failed') {
        this.onBackFn();
      }
      this.$store.commit('stopLoading');
    }
  }

  loadEditdetails() {
    const tenantModalObject = this.$store.getters['TenantManagementStoreModule/getNewTenantModalObject'];
    Object.assign(this.tenantModalObject, {
      MSSPname: tenantModalObject.msspName,
      tenantName: tenantModalObject.tenantName,
      productGroupId: tenantModalObject.productGroupId,
    });
  }

  getMSSPTenantPrefilterList() {
    this.msspOptions = [];
    return new Promise((res) => {
      MswApiService.usageReport.getMsspList()
      .then((resp: MSSPPrefilterResponseType) => {
        this.msspPrefilterResponseFromApi = resp;
        const msspOption: SelectOption[] = [];
        if (this.msspPrefilterResponseFromApi && this.msspPrefilterResponseFromApi.content && this.msspPrefilterResponseFromApi.content.MSSPs) {
          this.msspPrefilterResponseFromApi.content.MSSPs.map((ele: MsspPrefilterList) => {
            if (ele.MSSPName && ele.MSSPStatus !== 'INACTIVE') {
              msspOption.push({
                id: ele.MSSPID.toString(),
                label: ele.MSSPName,
                value: ele.MSSPStatus,
              });
            }
            if (ele.Tenants) {
              ele.Tenants.map((tenantEle: TenantPrefilterList) => {
                if (!this.tenantList.includes(tenantEle.TenantName)) {
                  this.tenantList.push(tenantEle.TenantName);
                }
              });
            }
          });
        }
        this.msspOptions = [...msspOption];
        if (this.tenantModalObject.MSSPname === '' && this.msspType === 'select' && this.modalMode === 'add') {
          this.tenantModalObject.MSSPname = this.msspOptions.length === 1 ? this.msspOptions[0].id : '';
        }
        res(true);
      })
      .catch(() => {
        res(true);
      });
    });
  }

  getTenantModalDetails() {
    return new Promise((res) => {
      MswApiService.tenant.getTenantFormDetails(this.tenantModalObject.productGroupId)
      .then((resp: any) => {
        const tenantResp = resp.tenantAddress || {};
        Object.assign(this.tenantModalObject, {
          companyName: tenantResp.companyName || '',
          contactName: tenantResp.contactName || '',
          emailAddress: tenantResp.emailAddress || '',
          streetAddress: tenantResp.streetAddress || '',
          cityName: tenantResp.city || '',
          stateName: tenantResp.stateCode || '',
          zipCode: tenantResp.zipCode || '',
          phoneNumber: tenantResp.phoneNumber || '',
          province: tenantResp.province || '',
          additionalMessage: tenantResp.additionalComments || '',
          countryName: tenantResp.countryCode || '',
          tenantNumber: tenantResp.msspTenantNumber || '',
          tenantContractId: tenantResp.tenantContractId || '',
        });
        res(true);
      })
      .catch((err: any) => {
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: err.msgDesc });
        res(false);
      });
    });
  }

  loadCountryStateList() {
    return new Promise((res) => {
      MswApiService.tenant.getCountryStateList()
      .then((resp: any) => {
        this.countryList = resp.content ? resp.content.lstCountries ? resp.content.lstCountries : [] : [];
        res(true);
      })
      .catch((err: any) => {
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: err.msgDesc });
        res(true);
      });
    });
  }

  async loadTenantModalApis() {
    try {
      this.$store.commit('startLoading');
      await this.loadCountryStateList();
      if (this.msspType === 'select') {
        await this.getMSSPTenantPrefilterList();
      }
      if (this.modalMode !== 'add') {
        await this.getTenantModalDetails();
      }
      // await this.getMsspUserGroupDetails();
      this.$store.commit('stopLoading');
    } catch {
      this.$store.commit('stopLoading');
    }
  }

  onEditProvince(value: string) {
    this.tenantModalObject.province = value;
  }
  get checkForMasterMsspRole() {
    const tempObj: any = localStorage.getItem(currentUserKey);
    const userInfoObtained: any = JSON.parse(tempObj);
    if (userInfoObtained.roles && userInfoObtained.roles.includes('MASTERMSSP')) {
      return true;
    }
    return false;
  }
  created() {
    this.addressVerificationEnabled = false;
    this.addressVerificationNeeded = '';
    this.loadTenantModalApis();
    const msspObjectFromStore = this.$store.getters['TenantManagementStoreModule/getNewMsspModalObject'];
    const tenantObjectFromStore = this.$store.getters['TenantManagementStoreModule/getNewTenantModalObject'];
    this.newMsspModalObject = Object.assign({}, {
      MSSPname: msspObjectFromStore.MSSPname,
      emailAddress: msspObjectFromStore.emailAddress,
      contactName: msspObjectFromStore.contactName,
      companyName: msspObjectFromStore.companyName,
      phoneNumber: msspObjectFromStore.phoneNumber,
      streetAddress: msspObjectFromStore.streetAddress,
      city: msspObjectFromStore.city,
      country: msspObjectFromStore.country,
      state: msspObjectFromStore.state,
      zipCode: msspObjectFromStore.zipCode,
      isDefaultGroup: msspObjectFromStore.isDefaultGroup,
      MSSPID: msspObjectFromStore.MSSPID,
      additionalComments: msspObjectFromStore.additionalComments,
      province: msspObjectFromStore.province,
      firstName: msspObjectFromStore.firstName,
      lastName: msspObjectFromStore.lastName,
      msspNumber: msspObjectFromStore.msspNumber,
      msspContractid: msspObjectFromStore.msspContractid,
    });
    this.tenantModalObject  = Object.assign({}, {
      MSSPname: tenantObjectFromStore.MSSPname,
      tenantName: tenantObjectFromStore.tenantName,
      contactName: tenantObjectFromStore.contactName,
      companyName: tenantObjectFromStore.companyName,
      emailAddress: tenantObjectFromStore.emailAddress,
      phoneNumber: tenantObjectFromStore.phoneNumber,
      streetAddress: tenantObjectFromStore.streetAddress,
      cityName: tenantObjectFromStore.cityName,
      countryName: tenantObjectFromStore.countryName,
      stateName: tenantObjectFromStore.stateName,
      zipCode: tenantObjectFromStore.zipCode,
      additionalMessage: tenantObjectFromStore.additionalMessage,
      province: tenantObjectFromStore.province || '',
      productGroupId: tenantObjectFromStore.productGroupId,
      tenantNumber: tenantObjectFromStore.tenantNumber,
      tenantContractId: tenantObjectFromStore.tenantContractId || '',
    });
    if (this.modalMode === 'add') {
      this.tenantModalObject.MSSPname = this.tenantModalObject.MSSPname ?
      this.tenantModalObject.MSSPname : this.newMsspModalObject.MSSPname || '';
    } else {
      this.loadEditdetails();
    }
  }
}
